import { AttributeModel } from "../main/dynamic/model/attribute.model"

export class TaggedUserModel {
    id: string
    name: string
    email?: string
    attributes?: AttributeModel[]
}